import styled from 'styled-components';
import React, {FC} from 'react';

import {StylableProps} from '../../../../lib/styleHelpers';
import {mediaBreakpointDown, palette} from '../../../../lib/styleVariables';
import {Renderer} from '../../../../lib/typeHelpers';
import {paletteR4} from '../../../../lib/styleVariablesR4';

interface NavigationCallToActionSimpleBaseProps {
  color?: string;
}

interface NavigationCallToActionBaseProps extends StylableProps {
  renderLeft: Renderer;
  wrapperCss?: string;
  leftCss?: string;
  renderRight: Renderer;
  rightCss?: string;
  color?: string;
}

interface NavigationCallToActionBaseLinkProps extends NavigationCallToActionBaseProps {
  href: string;
}

const getCtaBackground = (color?: string) => {
  switch (color) {
    case 'gray':
      return palette.white.base;
    case 'black':
      return palette.black.base;
    default:
      return paletteR4.red.base;
  }
};

const linkStyle = `
  text-decoration: none;

  &:any-link {
    color: inherit;
  }
`;

const StyledWrapperDiv = styled.div<{color?: string; asLink?: boolean; wrapperCss?: string}>`
  align-items: center;
  background: ${props => getCtaBackground(props.color)};
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 42px 104px;
  min-height: 168px;

  ${mediaBreakpointDown('tablet')} {
    padding: 32px;
  }

  ${mediaBreakpointDown('desktop')} {
    flex-direction: column;
  }
  ${props => (props.asLink ? linkStyle : '')}
  ${props => props.wrapperCss || ''};
`;

const StyledLeftSideDiv = styled.div<{$css?: string}>`
  text-align: left;
  padding-right: 24px;
  ${mediaBreakpointDown('mobile')} {
    padding-top: 0;
    margin-right: 0;
  }
  ${mediaBreakpointDown('desktop')} {
    margin-bottom: 20px;
    padding-right: 0;
    text-align: center;
  }
  ${props => props.$css}
`;

const StyledRightSideDiv = styled.div<{$css?: string}>`
  text-align: right;
  ${mediaBreakpointDown('mobile')} {
    width: 100%;
    margin-top: 18px;
    display: flex;
    flex-direction: column;
  }
  ${mediaBreakpointDown('desktop')} {
    text-align: center;
  }
  ${props => props.$css}
`;

const NavigationCallToActionCommon: FC<NavigationCallToActionBaseProps & {asLink?: boolean}> = props => (
  <StyledWrapperDiv as={props.asLink ? 'a' : undefined} {...props}>
    <StyledLeftSideDiv $css={props.leftCss}>{props.renderLeft()}</StyledLeftSideDiv>
    <StyledRightSideDiv $css={props.rightCss}>{props.renderRight()}</StyledRightSideDiv>
  </StyledWrapperDiv>
);

export const NavigationCallToActionSimpleBase: FC<StylableProps &
  NavigationCallToActionSimpleBaseProps> = props => (
    <StyledWrapperDiv {...props}>{props.children}</StyledWrapperDiv>
  );

export const NavigationCallToActionBase: FC<NavigationCallToActionBaseProps> = NavigationCallToActionCommon;

export const NavigationCallToActionBaseLink: FC<NavigationCallToActionBaseLinkProps> = props => (
  <NavigationCallToActionCommon {...props} asLink />
);
